module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\" ng-bind=\"'CONFIRM_DESTROY_RECORD' | translate\"></h5>\n  <span class=\"glyphicon glyphicon-remove\" ng-click=\"destroy.$onClose()\"></span>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"pull-right\">\n    <button\n      class=\"btn btn-dark\"\n      type=\"submit\"\n      ng-click=\"destroy.$onClose()\"\n      ng-bind=\"'CANCEL' | translate\">\n    </button>\n    <button\n      class=\"btn btn-danger\"\n      ng-click=\"destroy.$onDestroy()\"\n      ng-bind=\"'DESTROY_RECORD' | translate\">\n    </button>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/utility/destroy/destroy.html
 ** module id = 260
 ** module chunks = 0
 **/